import { baseDataPsmExecutors } from "./executor/index.js";
import { jsonDataPsmExecutors } from "./json-extension/executor/xml-data-psm-executor.js";
import { xmlDataPsmExecutors } from "./xml-extension/executor/xml-data-psm-executor.js";
export const dataPsmExecutors = [
    ...baseDataPsmExecutors,
    ...xmlDataPsmExecutors,
    ...jsonDataPsmExecutors,
];
//# sourceMappingURL=data-psm-executors.js.map